import { CoursesRepo } from "@/repos/CoursesRepo";
import { CourseModel } from "@/models/CourseModels";

// src/services/CourseService.ts
export class CourseService {
    constructor(private coursesRepo: CoursesRepo) { }

    async get(id: string): Promise<CourseModel | null> {
        return await this.coursesRepo.getById(id);
    }

    async create(item: CourseModel): Promise<void> {
        return await this.coursesRepo.create(item, item.id);
    }

    async update(id: string, updates: Partial<CourseModel>): Promise<void> {
        return await this.coursesRepo.update(id, updates);
    }

    async delete(id: string): Promise<void> {
        return await this.coursesRepo.delete(id);
    }
}